import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { useApplyForShift } from '~/hooks/api/useApplyForShift';
import appMessages from '~/containers/App/messages';
import ApplicationOptionsDialog from '../ApplicationOptionsDialog';
import messages from './messages';
import styles from './styles.module.css';

type ApplyForShiftButtonProps = {
  shiftId: number;
  isPlanningCompleted: boolean;
  isVehicleWorkflowActive: boolean;
};

const ApplyForShiftButton = (props: ApplyForShiftButtonProps) => {
  const [
    shouldShowApplicationOptionsDialog,
    setShouldShowApplicationOptionsDialog,
  ] = React.useState(false);
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();

  const applyForShiftMutation = useApplyForShift({
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.applyForShiftFailure),
      });
    },
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.applyForShiftSuccess),
      });
    },
  });
  return (
    <>
      {applyForShiftMutation.isPending ? (
        <div className={styles.button}>
          <Typography variant="body2">
            <FormattedMessage {...appMessages.loading} />
          </Typography>
        </div>
      ) : (
        <button
          type="button"
          className={styles.button}
          onClick={() => {
            if (props.isVehicleWorkflowActive) {
              setShouldShowApplicationOptionsDialog(true);
              return;
            }
            applyForShiftMutation.mutate({ shiftId: props.shiftId });
          }}
        >
          <Typography variant="body2">
            <AddIcon
              sx={{ fontSize: 16, verticalAlign: 'text-bottom', mr: 0.5 }}
            />
            {props.isPlanningCompleted ? (
              <FormattedMessage {...messages.applyForPlannedShift} />
            ) : (
              <FormattedMessage {...messages.applyForShift} />
            )}
          </Typography>
        </button>
      )}
      <ApplicationOptionsDialog
        open={shouldShowApplicationOptionsDialog}
        handleApplyForShift={(params) => {
          applyForShiftMutation.mutate({
            shiftId: props.shiftId,
            ...params,
          });
        }}
      />
    </>
  );
};

export default ApplyForShiftButton;
